import React, {useEffect, useState} from 'react';
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core";
import ScrollableAnchor from "react-scrollable-anchor";
import Radio from "@material-ui/core/Radio";
import clsx from "clsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import {DropzoneArea} from "material-ui-dropzone";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
    answerState, intFileState,
    menuCheckSelector,
    selectedMenuItemState,
    surveyDataState,
    userState
} from "../../state/globalState";
import {deleteBlobFile, fileUploadToAzureStorage, findFilesByFileGcd} from "../../lib/api/file";
import DropzoneFileItem from "../common/DropzoneFileItem";

const useStyles = makeStyles(theme => ({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#1b6817',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    textField: {
        width: 300
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

/**
 * 설문 문항 컴포넌트
 */
const Survey9 = (props) => {
    const userInfo = useRecoilValue(userState);
    const surveyData = useRecoilValue(surveyDataState);
    const [intFiles, setIntFiles] = useRecoilState(intFileState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const classes = useStyles();
    const intYn = answer.intYn;

    const getFiles = async (admnNo, stdYear) => {
        const { data } = await findFilesByFileGcd(admnNo, stdYear);
        if (data.success) {
            const files = data.payload.filter((file) => (file.kognrFileGcd === "HC050001"))
            console.log("New Files", files);
            setIntFiles(files);
        }
    }

    const handleInputAnswer = (e, column) => {
        const { value } = e.target;

        setAnswer({
            ...answer,
            diviYn: value,
            [column]: value
        });

        setSelectedMenuItem('SURVEY_19');
        setMenuCheck(value !== '');
    };

    const StyledRadio = (props) => {
        return (
            <Radio
                disableRipple
                color="default"
                checked={intYn === props.value}
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={(e) => handleInputAnswer(e, 'intYn')}
                {...props}
            />
        );
    };

    const step19List = surveyData[19].text.map((item) => {
        // item.content = item.content.replace('$stdYear$', appStore.getState().user.userInfo.stdYear);

        return (
            <>
                <FormControlLabel key={'19-' + item.key} name={String(item.toggle)} value={item.key}
                                  control={<StyledRadio />} label={item.content}/>
            </>
        )
    });

    const handleFilaChange = async (files) => {
        if (!files || files.length === 0) return;

        const opts = {
            stdYear: userInfo.stdYear,
            admnNo: userInfo.admnNo,
            attcFileBizGcd: "hc056002",
            kognrFileGcd: "HC050001",
        }

        for (const fileObj of files) {
            const { data } = await fileUploadToAzureStorage(fileObj, opts);
            if (data.success) {
                const { resultCode, resultMsg } = data.payload;
                if (resultCode !== "0000") {
                    console.error("File upload failed:", resultMsg);
                }
            }
        }

        await getFiles(userInfo.admnNo, userInfo.stdYear);
    };

    const handleDelete = async (fileUuid, bizFileSeq, fileSeq) => {
        const { data } = await deleteBlobFile(fileUuid, bizFileSeq, fileSeq);
        // api 통신 정상인지 확인
        if (data.success) {
            const result = await getFiles(userInfo.admnNo, userInfo.stdYear);
            console.log(result);
        }
    };


    return (
        <>
            <ScrollableAnchor id={"19"}>
                <div>
                <Container style={{background: 'transparent', marginBottom: '10px'}}>
                    <SentenceForm
                        title={surveyData[19].title}
                        sentences={surveyData[19].questions}
                        step={19}
                    />
                    {(intYn === '1' || (answer.intDiviYn === '1' && intYn === '0')) && (
                        <div>
                            <div className="blockquote-box">
                                <div>
                                    국외금융기관으로부터 수령한 이자, 배당소득 명세서를 업로드하여 주시기 바랍니다.
                                </div>
                                <div>
                                    파일형식 : 이미지파일, PDF파일, Excel 파일
                                </div>
                            </div>
                            <br/>
                            <div style={{marginLeft: '25px'}}>
                                <DropzoneArea
                                    acceptedFiles={[
                                        'application/pdf',
                                        'image/jpeg',
                                        'image/png',
                                        'application/vnd.ms-excel',
                                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                    ]}
                                    filesLimit={20}
                                    dropzoneText={'파일을 선택하거나 또는 여기로 끌어 주세요.'}
                                    maxFileSize={30000000}
                                    // showFileNames={true}
                                    showPreviewsInDropzone={false}
                                    showAlerts={false}
                                    onDrop={handleFilaChange}
                                    // onDelete={handleDelete}
                                    // initialFiles={intFiles.length && intFiles.map((file) => file.fileNm)}
                                />
                                {intFiles && intFiles.map((file) => <DropzoneFileItem {...file} />)}
                            </div>
                        </div>
                    )}
                    <FormControl component="fieldset" style={{margin: '10px 20px 0 25px'}}>
                        <RadioGroup defaultValue="0" aria-label="" name="" row>
                            {step19List}
                        </RadioGroup>
                    </FormControl>
                </Container>
                </div>
            </ScrollableAnchor>
        </>
    );
};

export default Survey9;
